/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {warmupCustomerContext} from '../api'

export const useMutationWarmupCustomerContext = createReactQueryMutationHook('warmupCustomerContext', warmupCustomerContext)
